import React, { useEffect, useState } from 'react';
import "../../styles/jobtype.css";
import { ToastContainer, toast } from "react-toastify";

const JobType_popup = ({ closePopup, onSubmit, editData }) => {
    const [job_type_code, setCode] = useState('');
    const [job_type_name, setName] = useState('');
    const [job_type_division, setDivision] = useState('');
    const [id, setId] = useState(0);
    const [errors, setErrors] = useState({
        job_type_code: '',
        job_type_name: '',
        job_type_division: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        setErrors({
            job_type_code: '',
            job_type_name: '',
            job_type_division: ''
        });

        let hasError = false;
        const newErrors = {
            job_type_code: '',
            job_type_name: '',
            job_type_division: ''
        };

        if (!job_type_code.trim()) {
            newErrors.job_type_code = 'Please enter the job type code';
            hasError = true;
        }

        if (!job_type_name.trim()) {
            newErrors.job_type_name = 'Please enter the job type name';
            hasError = true;
        }

        if (!job_type_division) {
            newErrors.job_type_division = 'Please select type';
            hasError = true;
        }

        if (hasError) {
            setErrors(newErrors);
            return;
        }

        const formData = {
            id,
            job_type_code,
            job_type_name,
            job_type_division: job_type_division.toLowerCase()
        };

        onSubmit(formData);
    };

    const handleClear = () => {
        setCode('');
        setName('');
        setDivision('');
        setErrors({
            job_type_code: '',
            job_type_name: '',
            job_type_division: ''
        });
    };

    const handleDivisionToggle = (value) => {
        setDivision((prev) => (prev === value ? '' : value));
        setErrors((prev) => ({
            ...prev,
            job_type_division: ''
        }));
    };

    useEffect(() => {
        if (editData) {
            setCode(editData.job_type_code || '');
            setName(editData.job_type_name || '');
            setDivision((editData.job_type_division || '').toLowerCase());
            setId(editData.id);
        }
    }, [editData]);

    return (
        <>
            <div className="job-type-popup-overlay">
                <div className="job-type-popup-container">
                    <div className="job-type-creation-popup-header">
                        <h2>{editData ? 'Edit Job Type' : 'Create New Job Type'}</h2>
                        <button className="close-button" onClick={closePopup}>×</button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="job-type-creation-popup-body">
                            <div className="scope-creation-form-group">
                                <label htmlFor="code" className="job-type-popup-label">
                                    Code <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    id="job_type_code"
                                    className="job-type-popup-input"
                                    placeholder="Enter code.."
                                    style={{ margin: '0px' }}
                                    value={job_type_code}
                                    onChange={(e) => setCode(e.target.value)}
                                />
                                {errors.job_type_code && (
                                    <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                                        {errors.job_type_code}
                                    </div>
                                )}
                            </div>

                            <div className="scope-creation-form-group">
                                <label htmlFor="name" className="job-type-popup-label">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    id="job_type_name"
                                    className="job-type-popup-input"
                                    placeholder="Enter here..."
                                    value={job_type_name}
                                    onChange={(e) => setName(e.target.value)}
                                    style={{ margin: '0px' }}
                                />
                                {errors.job_type_name && (
                                    <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                                        {errors.job_type_name}
                                    </div>
                                )}
                            </div>

                            <div>
                                <div className="job-type-creation-form-group job-type-type-row">
                                    <label className="job-type-popup-label job-type-type-label">
                                        Type <span style={{ color: 'red' }}>*</span> :
                                    </label>

                                    <div className="job-type-radio-group">
                                        <div
                                            className={`job-type-radio-box ${job_type_division === 'scs' ? 'active' : ''}`}
                                            onClick={() => handleDivisionToggle('scs')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <span className="job-type-radio-circle"></span>
                                            <span className="job-type-radio-text">SCS</span>
                                        </div>

                                        <div
                                            className={`job-type-radio-box ${job_type_division === 'ff' ? 'active' : ''}`}
                                            onClick={() => handleDivisionToggle('ff')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <span className="job-type-radio-circle"></span>
                                            <span className="job-type-radio-text">FF</span>
                                        </div>
                                    </div>
                                </div>

                                {errors.job_type_division && (
                                    <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                                        {errors.job_type_division}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="job-type-creation-popup-footer">
                            <button type="button" className="job-type-popup-clear-btn" onClick={handleClear}>
                                Clear
                            </button>
                            <button type="submit" className="job-type-popup-submit-btn">
                                {editData ? 'Update' : 'Submit'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default JobType_popup;